import { cva } from 'class-variance-authority';
import clsx from 'clsx';

import { getChannelIconName } from '@/utils/channel-icon';

const channelIconVariants = cva('h-6', {
  variants: {
    variant: {
      small: 'w-6',
      large: 'w-auto',
    },
    defaultVariants: {
      variant: 'small',
    },
  },
});

interface ChannelIconProps {
  channelSlug: string;
  variant?: 'small' | 'large';
  className?: string;
}

export function ChannelIcon({
  channelSlug,
  variant = 'small',
  className,
}: ChannelIconProps) {
  const channelIcons: Record<string, { default: string }> = import.meta.glob(
    '@/assets/icons/channels/*/*.svg',
    { eager: true },
  );

  const iconSrc = (channel: string) =>
    channelIcons[
      `/src/assets/icons/channels/${variant}/${getChannelIconName(
        channel.toLowerCase(),
      )}.svg`
    ]?.default;

  if (!channelSlug || !iconSrc(channelSlug)) return null;

  return (
    <img
      key={channelSlug}
      src={iconSrc(channelSlug)}
      alt="Channel"
      className={clsx(channelIconVariants({ variant, className }))}
    />
  );
}
